import { IFileSearch } from '@/client/legacy-shared-modules/search/search-types';

import type { SearchAIResults_VersionFilesByIds_versionFilesByIdsForAiAsk_results } from '../../graphql-types/SearchAIResults_VersionFilesByIds';
import { orderRecordsByIds } from '../../utils/contentHelpers';

function inferFileMimeType(file: {
  isVideo?: boolean | null;
  isImage?: boolean | null;
}): string {
  if (file.isVideo) return 'video';
  if (file.isImage) return 'image';
  return 'file';
}

function resolveOriginalPostId(
  versionFile: SearchAIResults_VersionFilesByIds_versionFilesByIdsForAiAsk_results
): string | undefined {
  return (
    versionFile.originalPost?._id ??
    versionFile.originalComment?.postV2?._id ??
    undefined
  );
}

export function mapVersionFilesByIdsToFileHits(
  versionFiles: SearchAIResults_VersionFilesByIds_versionFilesByIdsForAiAsk_results[],
  orderedVersionFileIds: string[]
): IFileSearch[] {
  return orderRecordsByIds(versionFiles, orderedVersionFileIds).map(
    (versionFile) => {
      const file = versionFile.file;
      const author = versionFile.author;
      const dateCreated = versionFile.dateCreated
        ? new Date(versionFile.dateCreated)
        : new Date(0);

      return {
        scope: [],
        objectID: versionFile._id,
        author: {
          _id: author?._id ?? '',
          firstName: '',
          lastName: '',
        },
        originalPostId: resolveOriginalPostId(versionFile),
        originalCommentId: versionFile.originalComment?._id ?? undefined,
        dateCreated,
        file: {
          _id: file?._id ?? versionFile._id,
          name: file?.name?.trim() || 'File',
          type: file ? inferFileMimeType(file) : 'file',
          size: 0,
        },
        displayName: author?.displayName?.trim() || '',
      };
    }
  );
}
